import NAMESPACES from './namespaces';
import { ROUTES } from './routes';

export const DOMAIN_NON_ID = 'none';

export const EMPTY_DOMAIN = {
  id: DOMAIN_NON_ID,
  name: 'None',
};

export const INTENT_MANAGER_ROUTES = {
  INTENT_MANAGER: 'intent_manager',
  DISCOVER: 'discover',
  BUILD: 'build',
  OPTIMIZE: 'optimize',
  ANALYZE: 'analyze',
  DOMAIN_SETTINGS: 'domain_settings',
};

export const INTENT_MANAGER_PORTALS = {
  INTENT_ANALYZER: 'INTENT_ANALYZER',
  INTENT_ANNOTATOR: 'INTENT_ANNOTATOR',
  INTENT_BUILDER: 'INTENT_BUILDER',
};

export function intentAnalyzerRouteToCaiRoute(route) {
  return Object.keys(INTENT_ANALYZER_ROUTES).find(tab => INTENT_ANALYZER_ROUTES[tab].includes(route));
}

export function routeToNamespace(routeName) {
  switch (routeName) {
    case ROUTES.INTENT_MANAGER:
    case INTENT_MANAGER_ROUTES.INTENT_MANAGER:
    case INTENT_MANAGER_ROUTES.ANALYZE:
    case INTENT_MANAGER_ROUTES.DISCOVER:
      return NAMESPACES.LIVE_INTENT;
    case INTENT_MANAGER_ROUTES.BUILD:
    case INTENT_MANAGER_ROUTES.DOMAIN_SETTINGS:
      return NAMESPACES.INTENT_BUILDER;
    case INTENT_MANAGER_ROUTES.OPTIMIZE:
      return NAMESPACES.INTENT_ANNOTATOR;
    default:
      return null;
  }
}

export const INTENT_ANALYZER_ROUTES = {
  [INTENT_MANAGER_ROUTES.INTENT_MANAGER]: '/app/intent_manager',
  [INTENT_MANAGER_ROUTES.ANALYZE]: '/app/intent/trends',
  [INTENT_MANAGER_ROUTES.DISCOVER]: '/app/intent/discovery',
};
